<template>
  <Modal :title="$t('lostConnectionModalTitle')" @close-modal="$emit('close-modal', false)">
    <div class="content">{{ $t("lostConnectionModalDescription") }}</div>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal"

export default {
  name: "LostConnectionModal",

  components: {
    Modal,
  },
}
</script>

<style lang="scss" scoped>
.content {
  background: #fff;
  padding: 2rem;
  margin: 1rem;
}
</style>
